import { ProductVariant, Region } from '@medusajs/medusa';
import { formatAmount } from 'medusa-react';

type LineItemOptionsProps = {
  variant: ProductVariant;
  region: Region;
};

const LineItemOptions = ({ variant, region }: LineItemOptionsProps) => {
  return (
    <div className="text-small-regular text-gray-700">
      {variant.options.map((option) => {
        const optionName =
          variant.product.options.find(
            (opt: any) => opt.id === option.option_id
          )?.title || 'Option';
        return (
          <div key={option.id}>
            <span>
              {optionName}:{' '}
              {formatAmount({
                amount: +option?.value ?? 0,
                region: region,
                includeTaxes: false,
              })}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default LineItemOptions;
